import React, { useState } from 'react';
import {
    Box,
    Container,
    Typography,
    Stack,
    Chip,
    Grid,
    Modal,
    Button,
} from '@mui/material';
import { formatDuration } from "../../utils/formatDuration";

function Hero({ lab }) {
    const [open, setOpen] = useState(false);

    return (
        <Box sx={{ backgroundColor: '#f9f9f9', py: 6 }}>
            <Container>
                <Grid container spacing={4}>
                    {/* Left Section */}
                    <Grid item xs={12} md={9}>
                        <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                            <Chip label='lab' color='primary' variant="outlined" />
                            <Chip label={lab.level} color='primary' variant="outlined" />
                        </Stack>

                        <Typography variant="h4" sx={{ fontWeight: 700, fontSize: { xs: '2rem', sm: '2.5rem' }, color: '#333', mb: 2 }}>
                            {lab.title}
                        </Typography>

                        <Typography variant="body2" sx={{ fontSize: '0.9rem', color: '#555', maxWidth: '700px', mb: 1, lineHeight: 1.6 }}>
                            {lab.description}
                        </Typography>

                        <Typography variant="body2" sx={{ fontSize: '0.9rem', color: '#555', maxWidth: '700px', mb: 3, lineHeight: 1.6 }}>
                            <Box component="span" sx={{ color: '#333', fontWeight: '600' }}>
                                Duration:
                            </Box>{" "}
                            {formatDuration(lab.duration)}
                        </Typography>

                        {/* Launch Button */}
                        <Box>
                            <Box
                                component="button"
                                onClick={() => setOpen(true)}
                                sx={{
                                    display: 'block',
                                    backgroundColor: 'primary.main',
                                    color: '#fff',
                                    textTransform: 'none',
                                    fontSize: '1.1rem',
                                    fontWeight: '500',
                                    border: 'none',
                                    borderRadius: 8,
                                    padding: '16px 48px',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s',
                                    '&:hover': {
                                        backgroundColor: 'primary.dark',
                                    },
                                }}
                            >
                                Launch Lab
                            </Box>
                        </Box>
                    </Grid>

                    {/* Right Section */}
                    <Grid item xs={12} md={3} />
                </Grid>
            </Container>

            {/* Modal */}
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="lab-access-modal"
                aria-describedby="lab-access-description"
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <Box
                    sx={{
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        borderRadius: 2,
                        p: 4,
                        width: '90%',
                        maxWidth: 480,
                        textAlign: 'center',
                    }}
                >
                    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
                        Access Required
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3 }}>
                        You don't have access to this lab. If you require access, please send an email to{' '}
                        <a href="mailto:hello@cloudsecnetwork.com" style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}>
                            hello@cloudsecnetwork.com
                        </a>
                    </Typography>
                    <Button variant="contained" fullWidth onClick={() => setOpen(false)}>
                        Close
                    </Button>
                </Box>
            </Modal>
        </Box>
    );
}

export default Hero;
